import { isSeatAvailableAndExistent } from './getIsSeatAvailableAndExistent';
export function getSeatCombinedWith(seat, seats, index) {
    const combinedWith = {};
    const prevSeat = seats === null || seats === void 0 ? void 0 : seats[index - 1];
    const nextSeat = seats === null || seats === void 0 ? void 0 : seats[index + 1];
    const isPrevSeatAvailable = prevSeat && isSeatAvailableAndExistent(prevSeat);
    const isNextSeatAvailable = nextSeat && isSeatAvailableAndExistent(nextSeat);
    if (seat.isAvailable && isPrevSeatAvailable) {
        combinedWith[prevSeat.number] = 'left';
    }
    if (seat.isAvailable && isNextSeatAvailable) {
        combinedWith[nextSeat.number] = 'right';
    }
    return combinedWith;
}
